module.exports = __webpack_public_path__ + "img/logo_semfundo.755333ce.png";